export const utils = [
  {
      name: "language",
      description: "Change the language for the bot",
      type: 1, /// SUBCOMMAND! = 1
      options: [
          {
              name: "input",
              description: "The new language",
              required: true,
              type: 3
          }
      ],
  },
  {
      name: "restart",
      description: "Shuts down the client!",
      type: 1 /// SUBCOMMMAND! = 1
  },
  {
      name: "control",
      description: "Enable or disable the player control",
      type: 1,
      options: [
          {
              name: "toggle",
              description: "Choose enable or disable",
              required: true,
              type: 3
          }
      ]
  },
  {
    name: "setup",
    description: "Setup channel song request",
    options: [
        {
            name: "type",
            description: "Type of channel",
            type: 3,
            required: true,
            choices: [
                {
                    name: "Create",
                    value: "create"
                },
                {
                    name: "Delete",
                    value: "delete"
                }
            ]
        },
    ],
  }
]